import { render, staticRenderFns } from "./cargoOwnerList.vue?vue&type=template&id=6acf4bf5&scoped=true"
import script from "./cargoOwnerList.vue?vue&type=script&lang=js"
export * from "./cargoOwnerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf4bf5",
  null
  
)

export default component.exports